import { useEffect as u } from "react";
const i = (r, o) => {
  u(() => {
    const e = (n) => {
      const s = r.map((t) => t && t.current).filter((t) => !!t);
      s.length > 0 && !s.some((t) => n.target && t.contains(n.target)) && o(n);
    };
    return document.addEventListener("mousedown", e), document.addEventListener("touchstart", e), () => {
      document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
    };
  }, [...r, o]);
};
export {
  i as useClickOutside
};
